/**
 * Main JavaScript file for Uit Holland theme
 */

document.addEventListener('DOMContentLoaded', function() {
    // Header functionality
    initHeaderScroll();
    initMobileMenu();
    initServiceSubmenuPosition();
});

/**
 * Initialize header scroll effects
 */
function initHeaderScroll() {
    const header = document.getElementById('header_main');
    if (!header) return;

    let lastScrollTop = 0;
    const scrollThreshold = 50;

    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const logo = header.querySelector('.logo-svg');
        const pageTitleWrapper = document.querySelector('.page-title-wrapper');
        
        // Calculate scale and opacity for title based on scroll (0-150px range)
        const scrollRange = 150;
        const scrollProgress = Math.min(scrollTop / scrollRange, 1);
        const scale = 1 - scrollProgress;
        const opacity = 1 - scrollProgress;
        
        // Add/remove scrolled class based on scroll position
        if (scrollTop > scrollThreshold) {
            header.classList.add('scrolled');
            // Shrink logo
            if (logo) {
                logo.style.height = '50px';
                logo.style.maxHeight = '50px';
                logo.style.minHeight = '50px';
            }
        } else {
            header.classList.remove('scrolled');
            // Restore logo size
            if (logo) {
                logo.style.height = '80px';
                logo.style.maxHeight = '80px';
                logo.style.minHeight = '80px';
            }
        }
        
        // Gradually shrink and fade title wrapper
        if (pageTitleWrapper) {
            // Just scale for all pages now
            pageTitleWrapper.style.transform = `scale(${scale})`;
            pageTitleWrapper.style.opacity = opacity;
        }
        
        // Update submenu position when title scales
        if (typeof initServiceSubmenuPosition !== 'undefined') {
            const submenuWrapper = document.querySelector('.service-submenu-wrapper');
            if (submenuWrapper && submenuWrapper.style.position === 'fixed') {
                // Call the update function from initServiceSubmenuPosition context
                const pageTitle = document.querySelector('.block-page-title');
                if (pageTitle) {
                    const event = new Event('updateSubmenuPosition');
                    window.dispatchEvent(event);
                }
            }
        }
        
        lastScrollTop = scrollTop;
    }

    // Set initial logo size
    const logo = header.querySelector('.logo-svg');
    if (logo) {
        logo.style.height = '80px';
        logo.style.maxHeight = '80px';
        logo.style.minHeight = '80px';
    }
    
    // Set initial state for page title
    const pageTitleWrapper = document.querySelector('.page-title-wrapper');
    const blockPageTitle = document.querySelector('.block-page-title');
    
    // Title positioning is now handled by CSS
    // Remove any inline styles that might interfere
    
    if (pageTitleWrapper) {
        // Same transform for all pages
        pageTitleWrapper.style.transform = 'scale(1)';
        pageTitleWrapper.style.opacity = '1';
    }

    // Initial check
    handleScroll();
    
    // Throttled scroll event
    let ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });
}

/**
 * Initialize mobile menu functionality
 */
function initMobileMenu() {
    const menuToggle = document.querySelector('.menu-toggle');
    const menuWrapper = document.querySelector('.primary-menu-wrapper');
    
    if (!menuToggle || !menuWrapper) return;
    
    // Toggle menu on button click
    menuToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        
        menuToggle.setAttribute('aria-expanded', !isExpanded);
        menuWrapper.classList.toggle('is-active');
        
        // Toggle menu button animation
        menuToggle.classList.toggle('is-active');
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
        if (!menuWrapper.contains(e.target) && !menuToggle.contains(e.target)) {
            menuToggle.setAttribute('aria-expanded', 'false');
            menuWrapper.classList.remove('is-active');
            menuToggle.classList.remove('is-active');
        }
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menuWrapper.classList.contains('is-active')) {
            menuToggle.setAttribute('aria-expanded', 'false');
            menuWrapper.classList.remove('is-active');
            menuToggle.classList.remove('is-active');
        }
    });
    
    // Prevent menu from closing when clicking inside it
    menuWrapper.addEventListener('click', function(e) {
        e.stopPropagation();
    });
}

/**
 * Position service submenu below page title dynamically
 */
function initServiceSubmenuPosition() {
    const pageTitle = document.querySelector('.block-page-title');
    const submenuWrapper = document.querySelector('.service-submenu-wrapper');
    
    if (!pageTitle || !submenuWrapper) return;
    
    function updateSubmenuPosition() {
        // Get the height and position of the page title
        const titleRect = pageTitle.getBoundingClientRect();
        const titleBottom = titleRect.bottom;
        
        // Get the current scale of the page title wrapper
        const pageTitleWrapper = document.querySelector('.page-title-wrapper');
        let currentScale = 1;
        if (pageTitleWrapper) {
            const transform = window.getComputedStyle(pageTitleWrapper).transform;
            if (transform && transform !== 'none') {
                const matrixValues = transform.match(/matrix.*\((.+)\)/);
                if (matrixValues) {
                    const values = matrixValues[1].split(', ');
                    currentScale = parseFloat(values[0]) || 1;
                }
            }
        }
        
        // Adjust spacing based on screen size and current scale
        const screenWidth = window.innerWidth;
        let spacing;
        
        // Account for different logo sizes and title scaling at breakpoints
        if (screenWidth > 1536) {
            spacing = 10;
        } else if (screenWidth > 1280) {
            spacing = 20 + (1 - currentScale) * 20; // Adjust for title scaling
        } else if (screenWidth > 1024) {
            spacing = 25 + (1 - currentScale) * 25; // More adjustment for smaller screens
        } else {
            // Below 1024px, submenu is relative positioned
            return;
        }
        
        // Calculate base position
        const basePosition = titleBottom + spacing;
        
        // Update position
        submenuWrapper.style.top = basePosition + 'px';
    }
    
    // Update position on load
    updateSubmenuPosition();
    
    // Update position when title scales (on scroll)
    window.addEventListener('updateSubmenuPosition', updateSubmenuPosition);
    
    // Only update on window resize if title might wrap
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            updateSubmenuPosition();
        }, 100);
    });
}